import { LogLevel } from '@azure/msal-browser';

const loggerCallback = (level: LogLevel, message: string, containsPii: boolean): void => {
  if (level !== LogLevel.Error || containsPii) {
    return;
  }

  console.error(message);
};

export const loggerOptions = {
  loggerCallback,
  logLevel: LogLevel.Error,
  piiLoggingEnabled: false,
};
